import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BannerImg from "../../../images/locationgcc/qa/Qatarblack.webp";

function whychoose(props) {
  return (
    <div
      className="whychoose p-100"
      style={{ backgroundImage: `url(${BannerImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={5}>
            <h2>Why Opt for TekRevol in Qatar for Mobile App Development?</h2>
            <p>
            TekRevol stands out as a premier mobile app development company in Qatar, recognizing the significance of Qatar's role in high-tech product development. Meanwhile, our established presence in the GCC region provides us with a profound understanding, enabling us to create customized mobility solutions for businesses seeking to enhance their brand presence and achieve tangible results.
            </p>
            <p>
            We take pride in delivering inventive and cost-effective solutions tailored to the distinctive requirements of each client. With our comprehensive mobile app development services, you can have confidence that your project is in capable hands.
            </p>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="choose-main">
              <div className="choose-box">
                <div className="choose-num">
                  300+<span>Apps Developed</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  65+<span>Review</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  35+<span>Industries Served</span>
                </div>
              </div>
            </div>
            <h5>Unlocking Business Potential with Our Applications</h5>
            <p>
            Our mission is to assist enterprises in discovering opportunities and solutions through our mobility services. With a proficient team of professionals, our app development company in Qatar adds substantial value to your business while delivering customer-centric services.
            </p>
            <h5>Engage Strategic and Consulting Expertise</h5>
            <p>
            Partner with us to gain clarity on your business needs, identify processes, streamline gaps, define user experiences, and create a technology roadmap aligned with your organizational objectives. Our collaborative approach ensures a comprehensive understanding of your business landscape.
            </p>
            <h5>Implement an Innovative Approach in Your System</h5>
            <p>
            Our product development team transforms your concepts into digital realities capable of generating high return on investment (ROI) and retention rates. We prioritize user research, user testing, design thinking, and aesthetics to formulate the ideal UI design and development strategy. 
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default whychoose;
